import ru from './ru';
import en from './en/index';

export default { ru, en };
